/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class User {
    getFixupPrototypeFunction() { return User.fixupPrototype; }

    static newInstance(model: Partial<User>): User {
        let obj = Object.assign(new User(), model);
        User.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<User>): User {
        if (!model) return null;
        return User.newInstance(<User> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: User) {
        if (!obj) return;

        models.User.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: User): boolean {
        Object.setPrototypeOf(obj, User.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.createdOn === "string") {
            this.createdOn = new Date(<string><any>this.createdOn);
        }
        if (typeof this.updatedOn === "string") {
            this.updatedOn = new Date(<string><any>this.updatedOn);
        }
        if (this.roles) {
            for (let val of this.roles) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
        if (this.groups) {
            for (let val of this.groups) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    sysId: string;

    createdOn: Date;

    updatedOn: Date;

    firstName: string;

    lastName: string;

    emailAddress: string;

    phoneNumber: string;

    roles: Array<models.RecordIdentity>;

    groups: Array<models.RecordIdentity>;

    origin: string;

}
